export { default } from './ActivitiesWithBoardDataProvider'
